import { css } from '@emotion/css';

export const styWrapper = css`
  overflow: hidden;
  justify-content: center;
`;

export const styTable = css`
  height: 100%;
  overflow-y: scroll;
`;

export const StyledThead = css`
  width: 50%;
`;
